import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  sectionIndent: {
    marginBottom: '42px'
  },
  inputIndent: {
    marginBottom: '24px'
  },
  summeryWrapper: {
    marginBottom: '30px'
  },
  summaryTitle: {
    color: '#757575',
    marginBottom: '12px',
    letterSpacing: '0.035em',
    textTransform: 'uppercase'
  },
  summaryActivityName: {
    marginBottom: '3px',
    fontWeight: 'bold'
  },
  summaryActivityInfo: {
    marginBottom: '5px'
  },
  summaryPricesList: {},
  summaryPricesItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    padding: '7px 0',
    letterSpacing: '0.035em',
    borderTop: '1px solid #e2ebf6',
    '&:last-child': {
      borderBottom: '1px solid #e2ebf6'
    }
  },
  summaryCurrency: {
    fontSize: '10px'
  },
  summaryPrice: {
    fontSize: '13px',
    fontWeight: 'bold'
  },
  summaryTotal: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '10px',
    borderBottom: '1px solid #e2ebf6'
  },
  summaryTotalPriceBlock: {
    letterSpacing: '0.035em'
  },
  summaryTotalPrice: {
    fontSize: '15px',
    fontWeight: 'bold'
  },
  addOnsSummaryWrapper: {
    marginBottom: '10px'
  },
  mandatoryFeesSummaryWrapper: {
    marginBottom: '10px'
  },
  relatedItem: {
    marginBottom: '10px',
    '&:last-child': {
      marginBottom: 0
    }
  }
});

export default useStyles;
